import { Component, OnInit, OnDestroy } from '@angular/core';
import * as firebase from 'firebase';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';
import { Router } from '@angular/router';
import { LoaderService } from '../../_services/loader.service';
import { SaveMessageComponent } from '../../directive/save-message/save-message.component';
import { MatDialog } from '@angular/material';
import { UserService } from '../../_services/user.service';
import { ApiService } from '../../_services/api.service';
import { Subscription } from 'rxjs';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.css']
})
export class DeleteAccountComponent implements OnInit, OnDestroy {
  user: any;
  subscription: Subscription;
  constructor(private modalService: NgbModal,
    private router: Router,
    private dialog: MatDialog,
    private loader: LoaderService,
    private userService: UserService,
    private apiService: ApiService,
    private afs: AngularFirestore) { }

  ngOnInit() {
  }

  open(content) {
    this.modalService.open(content);
  }

  async deleteAccount() {
    this.loader.load(true);
    if (!firebase.auth().currentUser) {
      this.loader.load(false);
      this.dialog.open(SaveMessageComponent, {
        width: '400px',
        data: {
          message: "Hesabının güvenliği için seni doğrulamamız gerekiyor. Lütfen tekrar giriş yap!",
          type: "update",
          info: "deleteAccount"
        }
      });
      return;
    }

    this.apiService.sqlDelete('users/Deleteuser', localStorage.getItem('currentUserId')).toPromise().then(a => a);

    await this.afs.collection('users').doc(localStorage.getItem('currentUserId')).ref.get().then((snap) => {
      this.afs.collection('deletedUsers').doc(localStorage.getItem('currentUserId')).set(snap.data()).then(() => {
        this.afs.collection('users').doc(localStorage.getItem('currentUserId')).collection('followIng').ref.get().then((following => {
          if (!following.empty) {
            following.forEach(user => {
              if (user.data().type === 'user') {
                this.afs.collection('users').doc(user.id).collection('followEr').doc(localStorage.getItem('currentUserId')).delete();
              }
              if (user.data().type === 'brand') {
                this.afs.collection('brands').doc(user.id).collection('followEr').doc(localStorage.getItem('currentUserId')).delete();
              }
              if (user.data().type === 'product') {
                this.afs.collection('products').doc(user.id).collection('followEr').doc(localStorage.getItem('currentUserId')).delete();
              }
            })

          }
        })).then(() => {
          this.afs.collection('users').doc(localStorage.getItem('currentUserId')).collection('followEr').ref.get().then((follower) => {
            if (!follower.empty) {
              follower.forEach(user => {
                if (user.data().type === 'user') {
                  this.afs.collection('users').doc(user.id).collection('followIng').doc(localStorage.getItem('currentUserId')).delete();
                }
              })
            }

          })
        }).then(() => {


          this.afs.collection('entities').ref.where('uniqueName', '==', snap.data().username).get().then((entities => {

            this.afs.collection('entities').doc(entities.docs[0].id).delete();
          }))
        })
          .then(() => {
            this.afs.collection('posts').ref.where('author.username', '==', snap.data().username).get().then((posts => {
              if (posts) {
                posts.forEach(dataPosts => {

                  this.afs.collection('posts').doc(dataPosts.id).delete();
                })
              }
            }))
          })
          .then(() => {

            this.afs.collection('posts').ref.where('repostedByUser.username', '==', snap.data().username).get().then((userID) => {
              userID.forEach(post => {

                this.afs.collection('posts').doc(post.id).delete();
              })
            }).then(() => {
              this.afs.collection('posts').ref.where('repostedFrom.username', '==', snap.data().username).get().then((repostedFrom => {
                repostedFrom.docs.map(post => {
                  this.afs.collection('posts').doc(post.id).delete();
                });
              }));
            })
          }).then(() => {
            this.apiService.sqlDeleteuniquename('users/removeByUniquename',
              snap.data().username).toPromise()

          }).then(() => {
            this.afs.collection('posts').ref.orderBy('comments').get().then(data => {
              let arr = [];
              data.docs.map(a => {
                a.data().comments.forEach(b => {

                  if (b.user.username == snap.data().username) {

                    arr = a.data().comments.filter(comment => {
                      return comment.user.username !== snap.data().username
                    });
                    this.afs.collection('posts').doc(a.id).update({
                      comments: arr
                    });


                  }
                });
              });

            });

          })
          .then(() => {
            this.afs.collection('users').doc(localStorage.getItem('currentUserId')).delete().then(() => {
              localStorage.clear();
              firebase.auth().currentUser.delete().then(() => {
                localStorage.clear();
                this.router.navigate(['/auth']);
                this.loader.load(false);
              }).catch((error) => {
                this.loader.load(false);
                this.router.navigate(['/auth']);
              });

            });
          });

      })

    })

  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/profile-update/delete-account/delete-account.component.ts